var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-page"},[_c('div',{staticClass:"empty-data"},[_c('div',{staticClass:"page-empty"},[_c('img',{attrs:{"src":require("@/assets/images/empty@2x.png")}})]),_c('p',[_vm._v("暂无页面权限")])])])
}]

export { render, staticRenderFns }